import { render, staticRenderFns } from "./Kaisha.vue?vue&type=template&id=4732f6b3&scoped=true&"
import script from "./Kaisha.vue?vue&type=script&lang=js&"
export * from "./Kaisha.vue?vue&type=script&lang=js&"
import style0 from "./Kaisha.vue?vue&type=style&index=0&id=4732f6b3&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4732f6b3",
  null
  
)

export default component.exports